import React, { useEffect, useContext, useState } from 'react';
import { useForm } from 'rac';
import './index.scss';
import {
  AuthorizationForm,
  OnetimePasswordForm,
  useAdminAuthorizationApi,
  useAdminOnetimePasswordApi,
} from 'api/admin/authorization';
import LoginForm from 'components/shared/login/login_form';
import OnetimePassword from 'components/shared/login/onetime_password';
import { GlobalStateContext } from 'contexts/global_state_context';
import { ReactRouterLocation } from 'entities/react_router';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { AdminRouteHelper } from 'routes/admin';
import CookieManager from 'utils/cookie_util';

const LoginPage: React.FC = () => {
  const api = useAdminAuthorizationApi();
  const globalState = useContext(GlobalStateContext);
  const form = useForm<AuthorizationForm>({ email: '', password: '' });

  const onetimeApi = useAdminOnetimePasswordApi();
  const [open, setOpen] = useState(false);
  const onetimeForm = useForm<OnetimePasswordForm>({ email: '', onetimeToken: '', onetimePassword: '' });

  const location = useLocation() as ReactRouterLocation;
  /** ログイン後のリダイレクト先 */
  const redirectUrlAfterLogin = location.state?.from.pathname || '/admin/laboratories';
  const navigate = useNavigate();

  useEffect(() => {
    globalState.setLoading(api.loading);
    if (!api.isSuccess()) return;

    if (api.response.accessToken) {
      CookieManager.saveAdminToken(api.response.accessToken);
      navigate(redirectUrlAfterLogin, { replace: true });
    } else if (api.response.onetimeToken) {
      onetimeForm.newUpdateObject('onetimeToken', api.response.onetimeToken);
      setOpen(true);
    }
  }, [api.loading]);

  useEffect(() => {
    globalState.setLoading(onetimeApi.loading);
    if (!api.isSuccess()) return;

    if (onetimeApi.response.accessToken) {
      CookieManager.saveAdminToken(onetimeApi.response.accessToken);
      navigate('/admin/laboratories');
    }
  }, [onetimeApi.loading]);

  const handleClickLoginButton = () => {
    onetimeForm.newUpdateObject('email', form.object.email);
    api.execute(form);
  };

  const handleClickOnetimeLoginButton = () => {
    onetimeApi.execute(onetimeForm);
  };

  if (CookieManager.hasAdminToken()) return <Navigate to={AdminRouteHelper.laboratoryIndex()} replace />;

  return (
    <div className="login">
      <OnetimePassword open={open} setOpen={setOpen} form={onetimeForm} handleClick={handleClickOnetimeLoginButton} />
      <LoginForm form={form} handleClick={handleClickLoginButton} />
    </div>
  );
};

export default LoginPage;
